module.exports = __webpack_public_path__ + "./fonts/c2b4e91d9501c46c101e443d0e8df346.woff";